// Make the `request` function generic

import { ApplicationPaths } from "../components/api-authorization/ApiAuthorizationConstants";

const handleAuthRedirect = (response: Response) => {
    if ([401].includes(response.status) || response.redirected) {
        window.location.href = ApplicationPaths.Login;
    }
};

const handleError = async (response: Response) => {
    if (response.status >= 400) {
        throw new Error(await response.text());
    }
};

// to specify the return data type:
export async function get<TResponse>(
    url: string,
    // `RequestInit` is a type for configuring 
    // a `fetch` request. By default, an empty object.
    config: RequestInit = {},
// This function is async, it will return a Promise:
): Promise<TResponse> {
    // Inside, we call the `fetch` function with 
    // a URL and config given:
    let response = await fetch(url, config);

    handleAuthRedirect(response);
    await handleError(response);
    
    // When got a response call a `json` method on it
    let data = response.json();

    // and return the result data.
    return data as unknown as TResponse;
};

export async function post(
    url: string,
    config: RequestInit = {},
): Promise<void> {
    let response = await fetch(url, {
        ...config,
        headers: [
            ['Content-Type', 'application/json'],
        ],
        method: 'POST',
    });

    handleAuthRedirect(response);
    await handleError(response);
};

export async function del(
    url: string,
    config: RequestInit = {},
): Promise<void> {
    let response = await fetch(url, {
        ...config,
        method: 'DELETE',
    });

    handleAuthRedirect(response);
    await handleError(response);
};

export async function put(
    url: string,
    config: RequestInit = {},
): Promise<void> {
    let response = await fetch(url, {
        ...config,
        headers: [
            ['Content-Type', 'application/json'],
        ],
        method: 'PUT',
    });

    handleAuthRedirect(response);
    await handleError(response);
};